<h1 mat-dialog-title>{{ edit ? 'Thema bearbeiten' : 'Thema erstellen' }}</h1>
<mat-dialog-content class="custom-scrollbar w800">
  <div class="pad-top8">
    <form [formGroup]="formGroup">
      <mat-form-field appearance="outline" class="w100">
        <mat-label>Name</mat-label>
        <input formControlName="nameCtrl" matInput placeholder="" required>
      </mat-form-field>
      <div (click)="openParentCategorySelect()" tabindex="0" class="w100">
        <mat-form-field appearance="outline" class="w100">
          <mat-label>Übergeordnetes Thema</mat-label>
          <mat-select formControlName="parentId" placeholder="">
            @if (selectedParentCategory) {
              <mat-option [value]="selectedParentCategory.id">{{ selectedParentCategory.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-dialog-close mat-raised-button>Abbrechen</button>
  <button (click)="save()" [disabled]="formGroup.controls['nameCtrl'].hasError('required')"
          color="primary" mat-raised-button>Speichern
  </button>
</mat-dialog-actions>
